import React, { useState ,useEffect } from "react";
import { Button, Input, Select, Spin, Table, Tooltip } from "antd";
import { AiFillAccountBook } from "react-icons/ai";
import AdminNavbar from "../Navbar/AdminNavbar";
import UserNavbar from "../Navbar/UserNavbar";
import { CustomerMasterAdd, CustomerMasterBlock, CustomerMasterDelete, CustomerMasterFindAll, CustomerMasterUpdate } from "../Api/All_Api";
import axios from "axios";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";
import TitleNavbar from "../Navbar/TitleNavbar";


const CustomerMaster = () => {
  const role = sessionStorage.getItem('role');
  const branchId = sessionStorage.getItem('branchId');

    const sessionYear = sessionStorage.getItem('sessionYear');
  const navigate = useNavigate();
      useEffect(() => {
        if (!sessionYear) {
          sessionStorage.clear();
          navigate('/')
        }
      },[])

  const [errors, setErrors] = useState({
    customerName: '',
    customeMobile:'',
    customerAddress:'',

  });

const [pageSize, setPageSize] = useState(10);
const [filteredData, setFilteredData] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [totalEntries, setTotalEntries] = useState(0);
const[allCustomer , setAllCustomer]=useState([]);
const [customerId, setCustomerId] = useState('');
const [customerName, setCustomerName] = useState('');
const [customerMobile, setCustomerMobile] = useState('');
const [customerAddress, setCustomerAddress] = useState('');
const [loading, setLoading] = useState(false);
const [updateButton, setUpdateButton] = useState(false);
const [saveButton, setSaveButton] = useState(true);


const handleSearch = (value) => {
  const filtered = allCustomer.filter((item) =>
    Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(value.toLowerCase())
    )
  );
  setFilteredData(filtered);
  setTotalEntries(filtered.length); // Update total entries count after filtering
  setCurrentPage(1);
};
//==========Pagination=======================
const handlePageSizeChange = (value) => {
  setPageSize(value);
};

  const handleCancel = () => {
    setUpdateButton(false);
    setSaveButton(true);
    setCustomerName('');
    setCustomerAddress('');
    setCustomerMobile('');
    setErrors('');
    fetchCustomer();
  };

  // ========Submit data to table==============
  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!customerMobile) {
      isValid = false;
      errorObj.customerMobile = "Mobile Number is required *";
    }
    if (!customerAddress) {
      isValid = false;
      errorObj.customerAddress = "Address is required *";
    }
    setErrors(errorObj); // Set error messages

    if (!isValid) return;
    setLoading(true);
    const bodyData ={
      customerName: customerName,
      customerMobile:customerMobile,
      customerAddress: customerAddress,
      branchId:parseInt(branchId),
     
    }

   
    try {
      const response = await axios.post(CustomerMasterAdd,bodyData );

      if (response.data === "CREATED") {
        toast.success('Customer added successfully!');
        fetchCustomer();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
        toast.warn('Customer already exist!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
    finally{
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCustomer();
  }, []);
  // ========Update data from table============
  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    window.scrollTo(0, 0);
    setCustomerName(item.customerName);
    setCustomerId(item.id);
    setCustomerAddress(item.customerAddress);
    setCustomerMobile(item.customerMobile);

  };
  let isError = false;
  const fetchCustomer = async () => {
    try {
      const response = await axios.get(`${CustomerMasterFindAll}?branchId=${parseInt(branchId)}`);
      if (response.data !== null) {
        setAllCustomer(response.data);
        setFilteredData(response.data);
        setTotalEntries(response.data.length); 
      }
      
    } catch (error) {
        if (!isError) {  
          console.error('Error fetching Customer:', error);
          toast.error('Failed to fetch customer data');
          isError = true;  
        }
    }
  };   
  const handleUpdate = async () => {
    let isValid = true;
    const errorObj = {};
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!customerMobile) {
      isValid = false;
      errorObj.customerMobile = "Mobile Number is required *";
    }
    if (!customerAddress) {
      isValid = false;
      errorObj.customerAddress = "Address is required *";
    }
    setErrors(errorObj); // Set error messages

    if (!isValid) return;
     setLoading(true);
    const bodyData ={
      id: customerId,
      customerName: customerName,
      customerAddress:customerAddress,
      customerMobile:customerMobile,
   
    }

    try {
      const response = await axios.put(CustomerMasterUpdate,bodyData );

      if (response.data === "UPDATED") {
        toast.success(' Updated successfully!');
        fetchCustomer();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
              toast.warn('Customer already exist!');
              handleCancel();
            }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while updating data');
    }
    finally{
      setLoading(false);
    }
  };

  // ========Delete data from table============
  // const handleDeleteData = async (item) => {
  //     const confirmDelete = window.confirm(`Are you sure you want to delete the location"${item.customerName}"?`);
  //     if (!confirmDelete) return;

  //     try {
  //       const response = await axios.delete(`${CustomerMasterDelete}?id=${item.id}`);
  //       if (response.data === "DELETED") {
  //         toast.success('Customer deleted successfully!');
  //         fetchCustomer();
  //         handleCancel();
  //       }
  //     } catch (error) {
  //       console.error('Error during delete operation:', error);
  //       toast.error('Error occurred while deleting the stream');
  //     }
  // };

  const toggleBlockStatus = async (item) => {
    const confirmDelete = window.confirm(`Are you sure you want to  ${item.customerStatus == 1 ? 'activate' : 'block'} ${item.customerName}?`);
    if (!confirmDelete) return;
    try {
     
      const updatedActiveStatus = item.customerStatus == 1 ? 0 : 1;
      

      const response = await axios.put(`${CustomerMasterBlock}?id=${item.id}&block=${updatedActiveStatus}` );
  
      if (response.data === "BLOCKED" || response.data === "UNBLOCKED") {
      
        setAllCustomer(
          allCustomer.map((c) =>
            c.id === item.id ? { ...c,customerStatus: updatedActiveStatus } : c
          )
        );
  
        fetchCustomer();
        toast.success(`Customer ${updatedActiveStatus === 1 ? 'blocked' : 'unblocked'} successfully!`);
      } else {
        
        toast.error('Failed to update block status.');
      }
    } catch (error) {
      // Catch errors and display a toast message
      toast.error('Error updating block status!');
      console.error('Axios error:', error);
    }
  };

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
    const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => index + 1,
    },
  
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Mobile No.",
      dataIndex: "customerMobile",
      key: "customerMobile",
    },
    {
      title: "Address",
      dataIndex: "customerAddress",
      key: "customerAddress",
    },
    {
      title: "Status",
      dataIndex: "customerStatus",
      key: "customerStatus",
      key: "customerStatus",
      render: (text) => (
       <span
       style={{
         display: "inline-block",
         padding: "2px 10px",
         color: "white",
         borderRadius: "4px",
         backgroundColor: text == "1" ? "red" : "green",
       }}
     >
       {text == "1" ? "Blocked" : "Active"}
     </span>
      ),
    },
    {
      title: "Edit",
      key: "edit",
      width:"60px",
      render: (text, record) => (
        <div    className="text-center"  >
          <span
           className='me-1 me-lg-2'
          type="submit"
          onClick={() => handleEditDataButton(record)}
            style={{
              fontSize: "12px",
              color: "orange",
             
            }}
          >
        <Tooltip title="Edit">   <i className="fa-solid fa-pen-to-square"></i></Tooltip> 
          </span>
          {/* <span
            type="submit"
          onClick={() => handleDeleteData(record)}
            style={{
              fontSize: "10px",
              color: "blue",
              marginLeft: "10px",
            }}
          >
            <i className="fa-solid fa-trash"></i>
          </span> */}

 
        </div>
      ),
    },
    {
      title: "Block",
      key: "block",
      width:"60px",
      render: (text, record) => (
        <div  className="text-center"  >

  <span
   className='me-1 me-lg-2'
          type="button"
          style={{
            fontSize: "12px", 
            color: record.customerStatus === 1 ? "red" : "green", 
           
            cursor: "pointer"
          }}
          onClick={() => toggleBlockStatus(record)} 
        >
         <Tooltip title={record.customerStatus === 1 ? "Blocked":"Active" }>   <i className={`fa-solid ${record.customerStatus == 1 ? 'fa-lock' : 'fa-unlock'}`}></i> </Tooltip>
        </span>
        </div>
      ),
    },
  ];
  const validateMobileNumber = (value) => {
    // Check if the entered value contains non-digit characters
    if (/[^0-9]/.test(value)) {
      setErrors({
        ...errors,
        customerMobile: 'Mobile number should contain only digits.',
      });
    } else {
      setErrors({
        ...errors,
        customerMobile: '', // Clear error if valid
      });
    }

    // Set the mobile number value
    setCustomerMobile(value);
  };

    //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================


  return (
    <>
      <AdminNavbar />
      <div className="p-0 m-0">
        {/* Header Section */}
        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <span className="px-md-5" style={{ flexGrow: 1 }}>
      <AiFillAccountBook  />&nbsp;
      Customer Master
    </span>

    {/* TitleNavbar (Right-aligned) */}
    <span>
      <TitleNavbar />
    </span>
          </div>
        
        </div>

       
        
        <div className='row m-0 p-0 pt-3'>
          <div className='col-12 col-md-2 col-lg-3'></div>
          <div className='col-12 col-md-8 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Name:</label>
          </div>
          <div className="col-9 col-md-4">
            <Input
              placeholder="Enter Customer Name"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
            {errors.customerName && (
              <div className="errorField">{errors.customerName}</div>
            )}
          </div>
        </div>
      </div>
      
    {/* Address Input */}
    <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Address:</label>
          </div>
          <div className="col-9">
            <TextArea
               maxLength="255"
              placeholder="Enter Address"
              value={customerAddress}
              onChange={(e) => setCustomerAddress(e.target.value)}
            />
            {errors.customerAddress && (
              <div className="errorField">{errors.customerAddress}</div>
            )}
          </div>
        </div>
      </div>
    

      <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Mobile No.:</label>
          </div>
          <div className="col-9 col-lg-6">
            <Input
              placeholder="Enter Mobile No."
                 maxLength="13"
              value={customerMobile}
              type="tel"
              onChange={(e) => validateMobileNumber(e.target.value)} 
            />
            {errors.customerMobile && (
              <div className="errorField">{errors.customerMobile}</div>
            )}
          </div>
        </div>
      </div>
   


    {/* Buttons Section */}
    <div className="col-12 text-center pt-3">
      <Button
        type="button"
        className="CancelBtn mx-1"
     
        onClick={handleCancel}
      >
        Cancel
      </Button>
      {saveButton && (
        <Button
          type="button"
          className="SubmitBtn mx-1"
        
          onClick={handleSubmit}
          disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Save'}
        </Button>
      )}
      {updateButton && (
        <Button
          type="button"
          className="UpdateBtn mx-1"
 
          onClick={handleUpdate}
          disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Update'}
        </Button>
      )}
    </div>
  </div>




          <div
            className="col-12 p-0 mt-3"
            style={{ borderBottom: "2px solid #bfb597" }}
          ></div>
          </div></div></div>
        <div className='col-12 col-md-2 col-lg-3'></div>
        

       

        {/*================ Table =========================*/}
                   <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
                   <div className='col-12 col-md-2'></div>
                     <div  className="col-12 col-md-8 py-3 shadow border"
                       style={{ marginBottom: "50px", backgroundColor: "white" }}
                     >
                       <div
                         className="col-12 px-md-5"
                         style={{ display: "flex", justifyContent: "space-between" }}
                       >
                         <div>
                           <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                           <Select
                             defaultValue={pageSize}
                             onChange={handlePageSizeChange}
                             style={{ width: 120, textAlign: "center" }}
                           >
                             <Option value={10}>10</Option>
                             <Option value={20}>20</Option>
                             <Option value={30}>30</Option>
                           </Select>
                         </div>
           
                         <div className="pt-4 pt-md-0">
                           <Input.Search
                             placeholder="Search"
                             onSearch={handleSearch}
                             style={{ width: 200, marginBottom: 16 }}
                           />
                         </div>
                       </div>
           
                       <div style={{ backgroundColor: "white" }}>
                         <Table
                           bordered
                           style={{ padding: "0px 20px", overflowX: "auto" }}
                           columns={columns}
                           dataSource={filteredData}
                           pagination={{
                             pageSize: pageSize,
                             total: totalEntries,
                             showTotal: (total, range) =>
                               `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                             current: currentPage,
                             onChange: (page) => setCurrentPage(page),
                           }}
                           showSorterTooltip={false}
                           rowKey={(record) => record.id}
                           components={components}
                         />
                       </div>
                     </div>
        </div>
    
    </>
  );
};

export default CustomerMaster;
